import React from "react";
import "./Testimonials.css";
import Common_Title from "../../common_components/common_title/Common_Title";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

const Testimonials = () => {
  return (
    <section className="Testimonials">
      <div className="container">
        <div className="content_holder">
          <div className="row">
            <div className="col-lg-5">
              <div className="left_side">
                <div className="title_div">
                  <Common_Title simpleText="Partner " darkText="Testimonials" />
                  <p className="bold_text">Hear directly form Our partners</p>
                </div>

                <div className="bottom_text_holder">
                  <p className="big_text">Our Sincere Thanks to Our Partners</p>
                  <p className="quote_text">
                    " Thank you for investing in this partnership with us. We
                    are incredibly grateful for your efforts and vision."
                  </p>
                </div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="review_div">
                <div className="img_div">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/home/testimonials/img.png"
                    }
                    className="img_class"
                  />
                </div>

                <div className="orange_div">
                  <Swiper
                    className="mySwiper "
                    spaceBetween={5}
                    autoplay={{
                      delay: 2500,
                      disableOnInteraction: true,
                    }}
                    modules={[Autoplay]}
                  >
                    <SwiperSlide>
                      <div className="orange_div_box">
                        <div className="quote_img_div">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/testimonials/quote.png"
                            }
                            className="quote_img"
                          />
                        </div>
                        <p className="review_text">
                          <b>“The payout transparency is unmatched.”</b>{" "}
                          Commissions are always on time and accurately
                          calculated. I’ve worked with other education partners
                          before, but Profcyma is the only one where payments
                          and communication are crystal clear.
                        </p>

                        <p className="name_text">
                          <b>— Pranavi Desai, </b> Ahmedabad
                        </p>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="orange_div_box">
                        <div className="quote_img_div">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/testimonials/quote.png"
                            }
                            className="quote_img"
                          />
                        </div>
                        <p className="review_text">
                          <b>“The payout transparency is unmatched.”</b>
                          Commissions are always on time and accurately
                          calculated. I’ve worked with other education partners
                          before, but Profcyma is the only one where payments
                          and communication are crystal clear.
                        </p>

                        <p className="name_text">
                          <b>— Pranavi Desai, </b> Ahmedabad
                        </p>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="orange_div_box">
                        <div className="quote_img_div">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/testimonials/quote.png"
                            }
                            className="quote_img"
                          />
                        </div>
                        <p className="review_text">
                          <b>“The support team deserves applause.”</b>
                          From onboarding to counselling to payout
                          clarifications — the support has always been fast and
                          professional. My RM is literally one call away
                          whenever I need help.
                        </p>

                        <p className="name_text">
                          <b>— Neha Kulkarni, </b> Pune
                        </p>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="orange_div_box">
                        <div className="quote_img_div">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/testimonials/quote.png"
                            }
                            className="quote_img"
                          />
                        </div>
                        <p className="review_text">
                          <b>
                            “Perfect for anyone who wants to work
                            independently.”
                          </b>
                          No pressure, no targets — just support and rewards. I
                          choose my working hours, manage my own network, and
                          still get all the tools and training to succeed.
                        </p>

                        <p className="name_text">
                          <b>— Sneha R., </b> Hyderabad
                        </p>
                      </div>
                    </SwiperSlide>

                    <SwiperSlide>
                      <div className="orange_div_box">
                        <div className="quote_img_div">
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/home/testimonials/quote.png"
                            }
                            className="quote_img"
                          />
                        </div>
                        <p className="review_text">
                          <b>
                            {" "}
                            “I never imagined I could earn this much from the
                            education sector.”
                          </b>
                          Earlier, I was just helping students casually. After
                          becoming a Profcyma Partner, I turned it into a
                          full-time career. Recurring commissions every semester
                          have changed my financial stability.
                        </p>

                        <p className="name_text">
                          <b>— Sandeep Verma, </b> Delhi
                        </p>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
